<template>
  <div class="updateDomain">
    <main class="t-main">
    <ol class="m-breadcrumb">
      <li class="m-breadcrumb__item"><router-link class="a-text a-link" to="/delivery/list-domain">ドメイン一覧</router-link></li>
      <li class="m-breadcrumb__item"><span class="a-text">ドメイン編集</span></li>
    </ol>
   <h1 class="a-title">{{ updateDomainTitle }}</h1>
   <div class="m-form__item-wrapper">
     <div class="m-form__item m-form__item--50">
       <label class="m-form__label">fqdn<span class="m-form__label--necessary">※変更不可</span>
         <h2 class="a-title a-title--sub">{{tasks.fqdn}}</h2>
       </label>
     </div>
   </div>
   <p class="a-button__wrapper">
     <button class="a-button" v-on:click="updateDomain">更新</button>
     <button class="a-button a-button--cansel" v-on:click="goListDomain">キャンセル</button>
   </p>
 </main>
  </div>
 </template>

<script>
import store from '../../../stores'
import { includes } from 'lodash'
import { domainRegexp } from '../../../constants'

export default {
  name: 'updateDomain',
  data() {
    return { updateDomainTitle: 'ドメイン編集' }
  },
  created() {
    store.dispatch('checkSessionId')
    store.state.domain.domain.fqdn = this.$route.query.fqdn
    store.dispatch('getDomainData')
  },
  computed: {
    tasks: { get() { return store.state.domain.domain } },
    // バリデーション関数を定義する
    upValidation: function () {
      return {
        fqdn: domainRegexp.test(this.tasks.fqdn)
      }
    },
    // バリデーションを読み込む関数
    isUpValid: function () {
      let msg = []
      if (this.tasks.fqdn == null || this.tasks.fqdn === '') {
        msg.push('fqdnは必須です')
      } else if (includes(this.upValidation, false || this.tasks.fqdn.length > 150)) {
        msg.push('入力項目に不備があります(150文字以内, e.g. example.com)')
      }
      return msg.join('\n')
    }
  },
  methods: {
    callDomain: function() { store.dispatch('domain', this.tasks) },
    updateDomain: function() {
      var errMsg = this.isUpValid
      if (errMsg === '') {
        store.dispatch('checkSessionId')
        store.dispatch('updateDomain', this.$router)
      } else {
        alert(errMsg)
      }
    },
    goListDomain: function() {
      this.$router.push('/delivery/list-domain')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/delivery/domain/UpdateDomain.vue